import React from 'react';
import { SpacerElement as SpacerType } from '../../types/element.types';

interface SpacerElementProps {
  element: SpacerType;
}

/**
 * Spacer Element Renderer
 * Creates vertical spacing between elements
 */
const SpacerElement: React.FC<SpacerElementProps> = ({ element }) => {
  const height = element.settings?.height || '40px';

  return (
    <div
      className="spacer-element"
      style={{
        ...element.styles,
        height,
      } as React.CSSProperties}
    />
  );
};

export default SpacerElement;

